import { Input } from 'antd'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import LabTechSelect from 'components/CIMSSelect/common/LabTechSelect'

const CreateEditBody: React.FC = () => {
  return (
    <>
      <CIMSFormItem
        name="name"
        label="Name"
        help={HelpMessage.Name}
        requiredMessage="Please enter a name"
      >
        <Input allowClear />
      </CIMSFormItem>
      <CIMSFormItem
        name="labTechs"
        label="Lab Techs"
        help={HelpMessage.Concrete.LabTechs.TestingLabs.LabTechs}
      >
        <LabTechSelect mode="multiple" />
      </CIMSFormItem>
    </>
  )
}

export default CreateEditBody
